import { render, staticRenderFns } from "./contactmessageinfo.vue?vue&type=template&id=d835764e&scoped=true&"
import script from "./contactmessageinfo.vue?vue&type=script&lang=ts&"
export * from "./contactmessageinfo.vue?vue&type=script&lang=ts&"
import style0 from "./contactmessageinfo.vue?vue&type=style&index=0&id=d835764e&lang=scss&scoped=true&"
import style1 from "./contactmessageinfo.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d835764e",
  null
  
)

export default component.exports